module.exports = __webpack_public_path__ + "images/_/javascripts/components/modal/guidance_slider_modal/images/title_342174ead0199cfdd706cb8ae5f44c2d.png";